import styled from 'styled-components';

export const HomeContainer = styled.div``;

export const HomeBody = styled.div`
  padding-bottom: 50px;
`;
